module.exports = __webpack_public_path__ + "static/media/button-ok.45843fb9.png";